Vendd.Scripts.load(function () {

    var hasLikeBox = $('.x-facebook-likebox').length > 0;
    var hasCustomerChat = $('.x-facebook-customer-chat').length > 0;
    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident/.test(ua);

    if ((hasLikeBox || hasCustomerChat) && !isIE) {
        var facebookSettings;
        var facebookSettingsEl = $('#facebook-settings');

        if (facebookSettingsEl.length > 0) {
            facebookSettings = {
                AppId: $(facebookSettingsEl[0]).data('facappid'),
                PageId: $(facebookSettingsEl[0]).data('facpageid')
            };

            facebookSettingsEl.remove();
        }
        
        if (facebookSettings) {
            window.fbAsyncInit = function () {
                FB.init({
                    appId: facebookSettings.AppId,
                    pageId: facebookSettings.PageId,
                    cookie: false,
                    xfbml: true,
                    version: 'v3.2'
                });
            }
        }

        (function (d, s, id) {
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id))
                return;

            var js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

});